// Source-of-truth for the UI locale on the storefront.
// Reads strictly from window.location.pathname (the URL prefix /es/, /en/, /de/, etc.).
// NEVER from i18next.language, Shopify.country, or sessionStorage — those can be
// contaminated by the country selector flow (see WI #8320).
// URL prefixes Shopify Markets actually serves for the Colombia market on
// stage.holacarrentals.com / holacarrentals.com. The header picker exposes:
// English (default — no prefix), Spanish (/es/), Italian (/it/),
// French (/fr/), German (/de/), Dutch (/nl/), Danish (/da/), and
// Portuguese Brazil (/pt/). `pt-BR`, `es-ES` and `en-GB` are kept for
// non-URL callers that may still pass the regional form from i18n or API
// responses. The list was verified empirically via Playwright against the
// live storefront (AB#8527).
const ACTIVE_LOCALES = [
    "en",
    "pt",
    "pt-BR",
    "de",
    "it",
    "fr",
    "es",
    "es-ES",
    "en-GB",
    "nl",
    "da",
];
// Match the leading URL segment as a locale.  Accepts the canonical case
// (`/es/`, `/pt-BR/`, `/en-GB/`) but is case-insensitive on the regional
// portion so that `/pt-br/` or `/en-gb/` are still recognized — Shopify's
// own redirects sometimes lowercase the region segment.
const URL_LOCALE_RE = /^\/([a-z]{2})(?:-([A-Za-z]{2}))?(?:\/|$)/;
function isActive(s) {
    return ACTIVE_LOCALES.includes(s);
}
function normalizeRegion(region) {
    return region.toUpperCase();
}
/**
 * Returns the active UI locale derived from the URL pathname.
 *
 * @param shape "lower" (default) returns the locale as-is (e.g. "es", "pt-BR", "en-GB").
 *              "upper" returns the API-shape uppercase form for matching against
 *              translations[].language (e.g. "ES", "PT" — collapsing pt-BR -> PT,
 *              es-ES -> ES — to match the API's coarse 2-letter language codes).
 * @returns one of the 8 active locales, or "en" / "EN" as fallback.
 */
export function getUrlLocale(shape = "lower") {
    let raw = "en";
    if (typeof window !== "undefined" && window.location && window.location.pathname) {
        const match = window.location.pathname.match(URL_LOCALE_RE);
        if (match) {
            const lang = match[1];
            const region = match[2];
            const candidate = region ? `${lang}-${normalizeRegion(region)}` : lang;
            if (isActive(candidate)) {
                raw = candidate;
            }
            else if (process.env.NODE_ENV !== "production") {
                // eslint-disable-next-line no-console
                console.warn(`[getUrlLocale] URL prefix "${candidate}" is not in the 8-locale allowlist; falling back to "en".`);
            }
        }
    }
    if (shape === "upper") {
        return raw.split("-")[0].toUpperCase();
    }
    return raw;
}
export default getUrlLocale;
